import { Component, OnInit, Injectable } from '@angular/core';
import { ChonDeNghiTamUngService } from './chon-de-nghi-tam-ung-service/chon-de-nghi-tam-ung.service';
import { BehaviorSubject } from 'rxjs';
import { QueryParamsModel } from 'app/core/_base/crud';

@Component({
    selector: 'kt-chon-de-nghi-tam-ung',
    templateUrl: './chon-de-nghi-tam-ung.component.html',
    styleUrls: ['./chon-de-nghi-tam-ung.component.scss']
})
@Injectable()
export class ChonDeNghiTamUngComponent implements OnInit {

  constructor(
		private chonDeNghiTamUngService : ChonDeNghiTamUngService
	) {}

  ngOnInit() {
    if (this.chonDeNghiTamUngService != undefined)
			this.chonDeNghiTamUngService.lastFilter$ = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
  }

}
